
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 定时任务列表
export function timedTasks (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/timedTasks',
    method: 'GET',
    params: parameter
  })
}
// 修改定时任务
export function timedTask (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/timedTask',
    method: 'POST',
    data: parameter
  })
}
// 修改定时任务获取下次执行时间
export function getNextExecution (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/timedTask/getNextExecution',
    method: 'GET',
    params: parameter
  })
}
// 定时任务日志
export function timedTaskLogs (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/timedTaskLogs',
    method: 'GET',
    params: parameter
  })
}
// 定时任务日志详情
export function timedTaskLogDetail (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/timedTaskLog',
    method: 'GET',
    params: parameter
  })
}
